<template>
  <HeaderContent title="Room Category" />
  <ActionContent
    ctaText="Add Room Category"
    @action="showModal"
    :filterDate="false"
    :filterModal="false"
    @search-query="searchData"
  />
  <RoomCategoryStatistics title="Room Category Statistics" :data="statistics" />
  <RoomCategoryForm
    :modal="modal"
    :roomCategoryData="roomCategory"
    @update:modal="updateModal"
    @addOrUpdate="getAll"
  />
  <!-- <BModal
    v-if="priceModal"
    :model-value="priceModal"
    scrollable
    centered
    title="Room Category Price"
    hide-footer
    @update:modelValue="updatePriceModal"
  >
    <template #header>
      <div
        class="d-flex align-items-center justify-content-between modal-title w-100"
      >
        <h5>Room Category Price</h5>
      </div>
      <BButton variant="link" class="close" @click="updatePriceModal(false)">
        <i class="ion ion-android-close"></i>
      </BButton>
    </template>

    <BForm @submit.prevent="savePrice">
      <div class="form-group">
        <label>Room Category</label>
        <BFormSelect
          v-model="formPrice.room_category_uuid"
          :options="roomCategoryOptions"
          required
        />
      </div>

      <div class="form-group">
        <label>Source Type</label>
        <BFormSelect
          v-model="formPrice.source_type"
          :options="sourceTypeOptions"
          required
        />
      </div>

      <div class="form-group">
        <label>Season</label>
        <BFormSelect
          v-model="formPrice.season"
          :options="seasonOptions"
          required
        />
      </div>

      <div class="form-group">
        <label>Price</label>
        <BFormInput v-model="formPrice.price" type="number" required />
      </div>

      <div class="d-flex justify-content-end">
        <BButton type="submit" variant="primary">Simpan</BButton>
        <BButton
          variant="secondary"
          class="ms-2"
          @click="updatePriceModal(false)"
          >Batal</BButton
        >
      </div>
    </BForm>
  </BModal> -->

  <RoomCategoryConfirm
    title="Confirmation"
    :uuid="roomCategoryUuid"
    v-model="modalConfirm"
    @confirmed="deleteData(roomCategoryUuid)"
  >
    <template #text>Are you sure to delete this data ?</template>
  </RoomCategoryConfirm>
  <RoomCategoryDataTable
    :data="roomCategories"
    :header="headers"
    :currentPage="currentPage"
    :custom-actions="customActions"
  />
</template>

<script>
import HeaderContent from "@/components/HeaderContent.vue";
import ActionContent from "@/components/ActionContent.vue";
import RoomCategoryForm from "./RoomCategoryForm.vue";
import RoomCategoryDataTable from "@/components/DataTable.vue";
import RoomCategoryStatistics from "@/components/StatisticData.vue";
import RoomCategoryConfirm from "@/components/ModalDialog.vue";
import iconDormRoom from "../../../public/icons/dorm-room.svg";
import { ref, inject, onMounted, computed } from "vue";
import { formatIDR } from "@/utils/currency";

export default {
  components: {
    HeaderContent,
    ActionContent,
    RoomCategoryForm,
    RoomCategoryDataTable,
    RoomCategoryStatistics,
    RoomCategoryConfirm,
  },
  setup() {
    const repositories = inject("repositories");
    const roomCategoryRepository = repositories
      ? repositories.roomCategory
      : null;
    const modal = ref(false);
    const modalConfirm = ref(false);
    const roomCategoryUuid = ref(null);
    const roomCategory = ref({});
    const roomCategories = ref([]);

    // * codingan:tambahan baru*
    // --- state untuk price modal ---
    const priceModal = ref(false);

    const defaultFormPrice = {
      uuid: null,
      room_category_uuid: null,
      source_type: "",
      season: "",
      price: null,
    };

    const formPrice = ref({ ...defaultFormPrice });

    // opsi static
    const sourceTypeOptions = [
      { value: "direct_booking", text: "Direct Booking" },
      { value: "walk_in", text: "Walk In" },
      { value: "booking_online", text: "Booking Online" },
      { value: "agent", text: "Agent" },
    ];

    const seasonOptions = [
      { value: "low", text: "Low Season" },
      { value: "high", text: "High Season" },
    ];

    // computed untuk pilihan kategori di modal
    const roomCategoryOptions = computed(() =>
      roomCategories.value.map((rc) => ({ value: rc.uuid, text: rc.name }))
    );

    const headers = ref([
      {
        key: "no",
        label: "No",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "name",
        label: "Room Category",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "source_type",
        label: "Source",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },
      {
        key: "low_season_price",
        label: "Low Season Price",
        thClass: "text-right",
        tdClass: "text-right",
        sortable: true,
        formatter: (value) => formatIDR(value),
      },
      {
        key: "high_season_price",
        label: "High Season Price",
        thClass: "text-right",
        tdClass: "text-right",
        sortable: true,
        formatter: (value) => formatIDR(value),
      },
      {
        key: "description",
        label: "Description",
        thClass: "text-left",
        tdClass: "text-left",
        sortable: true,
      },

      {
        key: "action",
        label: "Actions",
      },
    ]);

    const customActions = ref([
      //**tidak dipakai lagi */
      // {
      //   label: "Set Prices",
      //   variant: "info",
      //   icon: "fas fa-tags",
      //   // action: (item) => {
      //   //   addPrice(item);
      //   // },
      //   action: (item) => updatePriceModal(true, null, item.uuid), // tambah harga baru utk kategori tsb
      // },
      {
        label: "Edit",
        variant: "success",
        icon: "fas fa-edit",
        action: (item) => {
          getById(item.uuid);
        },
      },
      {
        label: "Delete",
        variant: "danger",
        icon: "fas fa-trash",
        action: (item) => {
          showConfirmModal(item.uuid);
        },
      },
    ]);

    const statistics = ref([]);

    // **tambah codingan baru: naldi*
    // open modal untuk tambah harga (pake item baris)
    const addPrice = (room) => {
      formPrice.value = {
        uuid: null,
        room_category_uuid: room.uuid,
        source_type: "",
        season: "",
        price: null,
      };
      priceModal.value = true;
    };

    // open modal untuk edit price (dari baris)
    const editPrice = (room, price) => {
      formPrice.value = {
        uuid: price.uuid || null,
        room_category_uuid: room.uuid,
        source_type: price.source_type || "",
        season: price.season || "",
        price: price.price || null,
      };
      priceModal.value = true;
    };

    const updatePriceModal = (val) => {
      priceModal.value = val;
    };

    const savePrice = async () => {
      try {
        if (formPrice.value.uuid) {
          await roomCategoryRepository.updatePrice(
            formPrice.value,
            formPrice.value.uuid
          );
        } else {
          await roomCategoryRepository.createPrice(formPrice.value);
        }
        priceModal.value = false;
        await getAll(); // refresh data kategori (akan membawa nested prices)
        formPrice.value = { ...defaultFormPrice };
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          alert(err.response.data.message);
        } else {
          console.error(err);
          alert("Error saving price");
        }
      }
    };

    const deletePrice = async (uuid) => {
      if (!confirm("Hapus harga ini?")) return;
      try {
        await roomCategoryRepository.deletePrice(uuid);
      } catch (err) {
        console.error(err);
        alert("Error deleting price");
      }
    };

    // const formatIDR = (value) => {
    //   const num = Number(value);
    //   if (!num || isNaN(num)) return "Rp 0";
    //   return new Intl.NumberFormat("id-ID", {
    //     style: "currency",
    //     currency: "IDR",
    //     minimumFractionDigits: 0,
    //   }).format(num);
    // };

    const formatSource = (str) => {
      if (!str) return "N/A";
      return str.replaceAll("_", " ").replace(/\b\w/g, (c) => c.toUpperCase());
    };

    const getAll = async () => {
      await roomCategoryRepository
        .getAll()
        .then((res) => {
          //**codingan lama */
          // const mapRoomCategories = res.data.data.map((i) => ({
          //   ...i,
          //   room_category: i.name,
          // }));

          const mapRoomCategories = res.data.data.flatMap((i) => {
            const prices = i.prices || [];

            // Group berdasarkan source_type
            const grouped = prices.reduce((acc, p) => {
              if (!acc[p.source_type]) {
                acc[p.source_type] = { low: null, high: null };
              }
              acc[p.source_type][p.season] = Number(p.price); // pastikan angka
              return acc;
            }, {});

            // Ubah hasil group ke format final per source
            return Object.entries(grouped).map(([source_type, val]) => ({
              uuid: i.uuid,
              name: i.name,
              source_type: formatSource(source_type),
              low_season_price: val.low || 0, // angka mentah
              high_season_price: val.high || 0, // angka mentah
              description: i.description || "-",
              housekeeping_commission: i.housekeeping_commission || 0,
            }));
          });

          roomCategories.value = mapRoomCategories;

          statistics.value = [
            {
              label: "Total",
              key: "Room Category",
              value: res.data.data.length,
              color: "primary",
              icon: iconDormRoom,
            },
          ];
        })
        .catch((err) => {
          console.error(err);
        });
    };

    // **codingan lama: madhan*
    const getById = async (uuid) => {
      await roomCategoryRepository
        .getById(uuid)
        .then((res) => {
          roomCategory.value = res.data.data;
          modal.value = true;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    // // ** codingan baru: naldi*
    // const getById = async (uuid) => {
    //   try {
    //     const res = await roomCategoryRepository.getById(uuid);
    //     const data = res.data.data;

    //     console.log("✅ Data dari API:", data);

    //     // ✅ rakit ulang prices agar cocok dengan form
    //     const sources = ["direct_booking", "walk_in", "agent", "booking_online"];

    //     const formattedPrices = sources.map((source) => {
    //       const low = data.prices.find(
    //         (p) => p.source_type === source && p.season === "low"
    //       );
    //       const high = data.prices.find(
    //         (p) => p.source_type === source && p.season === "high"
    //       );

    //       return {
    //         source_type: source,
    //         low_season_price: low ? Number(low.price) : 0,
    //         high_season_price: high ? Number(high.price) : 0,
    //       };
    //     });

    //     // ✅ assign tanpa ganggu reactivity
    //     roomCategory.value = {
    //       ...data,
    //       prices: formattedPrices,
    //     };

    //     console.log("🧩 roomCategory final:", roomCategory.value);

    //     // ✅ tampilkan modal terakhir biar pasti kebuka
    //     modal.value = true;
    //   } catch (err) {
    //     console.error(err);
    //   }
    // };


    const updateModal = (newValue) => {
      modal.value = newValue;
      roomCategory.value = {};
    };

    const showModal = () => {
      modal.value = true;
    };

    const showConfirmModal = (uuid) => {
      modalConfirm.value = true;
      roomCategoryUuid.value = uuid;
    };

    const deleteData = async (uuid) => {
      console.log(uuid);
      await roomCategoryRepository
        .delete(roomCategoryUuid.value)
        .then(() => {
          modalConfirm.value = false;
          getAll();
        })
        .catch((err) => {
          console.error(err);
        });
    };

    const searchData = async (keyword) => {
      await roomCategoryRepository
        .search(keyword)
        .then((res) => {
          roomCategories.value = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    };

    onMounted(() => {
      getAll();
    });

    return {
      modal,
      modalConfirm,
      roomCategoryUuid,
      roomCategory,
      roomCategories,
      headers,
      customActions,
      statistics,
      updateModal,
      showModal,
      showConfirmModal,
      deleteData,
      getAll,
      getById,
      searchData,
      priceModal,
      formPrice,
      sourceTypeOptions,
      seasonOptions,
      roomCategoryOptions,
      addPrice,
      editPrice,
      savePrice,
      deletePrice,
      updatePriceModal,
    };
  },
};
</script>
